import AnimatedCounter from './AnimatedCounter';
export { AnimatedCounter };